/**
 * 代管集团投资股权收益（山东省金融资产管理有限公司股权分红情况）
 */

/** 将接口明细转为表格/图表展示格式 */
export function mapManagedGroupIncomeRecords(list) {
	return (list || []).map((item) => ({
		year: item.incomeYear != null ? `${item.incomeYear}年` : '',
		income: item.incomeAmount != null ? String(item.incomeAmount) : '',
	}));
}

/** 长投收益金额合计（万元） */
export function calcTongxingIncomeTotal(records = []) {
	const total = records.reduce((sum, item) => {
		const n = parseFloat(String(item.income).replace(/,/g, ''));
		return sum + (Number.isFinite(n) ? n : 0);
	}, 0);
	return total.toFixed(2);
}
